<span *ngIf="shouldDisplay" class="{{fullButton ? '' : 'btn-circle-icon btn-circle-small align-self-center btn-default'}} {{extraClass}}" (click)="copyToClipboard(businessKey)">
    <i class="fa-regular fa-key" *ngIf="businessKey"
        tooltip="{{businessKeyTooltip}}: {{businessKey}}" placement="{{tooltipPosition}}"></i>
    <span *ngIf="fullButton">
        {{ "Business Key" | translate }}
    </span>
</span>

